import { getIdDisplayValue } from '@utils/index';
import { useLocationMapQuery, useLocationQuery, useNameMapQuery } from '@features/redux/apis/org';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { Locations as LocationsIcon } from '@assets/index';
import { useStyles } from './styles/ViewSystemLocation.styles';
import { FormDisabledText } from '@components/forms/text/base/FormDisabledText';
import { BillingType, WarrantyType } from '@consts/company';
import { Link } from 'react-router-dom';

type ViewSystemLocationProps = {
    locationId: number | null | undefined;
};

export const ViewSystemLocation = ({ locationId }: ViewSystemLocationProps) => {
    const classes = useStyles();
    const { data: nameMap } = useNameMapQuery({});
    const { data: locationMap } = useLocationMapQuery({});
    const { data: location, isLoading } = useLocationQuery({ locationId: locationId! }, { skip: !locationId });

    const { companyId, resellerId } = Object.fromEntries(locationMap?.locations || [])?.[locationId!] ?? {};

    return (
        <>
            {isLoading ? (
                <Box className={classes.box} height='200px'>
                    <CircularProgress size='75px' />
                </Box>
            ) : !locationId ? (
                <Box className={classes.box}>
                    <LocationsIcon />
                    <Typography fontWeight='bold'>This RapidCut system is not yet assigned to any location.</Typography>
                </Box>
            ) : (
                <Box display={'flex'} flexDirection={'column'} flex={1} gap={'10px'} mt={'10px'}>
                    <Box display={'flex'} flexDirection={'row'} gap={'10px'} ml={'10px'}>
                        <Typography fontSize={'14px'}>Manage Location Link:</Typography>
                        <Link to={`/manage/organizations?type=location&id=${locationId}`}>
                            <Typography fontSize={'14px'}>{nameMap?.locations[locationId]}</Typography>
                        </Link>
                    </Box>

                    <Grid container spacing={1} flexDirection='row' gap={1} p={1}>
                        <Grid item xs={12} sm={12} md={5.8} lg={5.8} xl={5.8}>
                            <FormDisabledText
                                value={getIdDisplayValue(location?.LocationID)}
                                label={'Location ID'}
                                size={12}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={5.8} lg={5.8} xl={5.8}>
                            <FormDisabledText
                                value={location?.LocationName || 'N/A'}
                                label={'Location Name'}
                                size={12}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={5.8} lg={5.8} xl={5.8}>
                            <FormDisabledText
                                value={nameMap?.companies[companyId] || 'N/A'}
                                label={'Company Name'}
                                size={12}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={5.8} lg={5.8} xl={5.8}>
                            <FormDisabledText
                                value={resellerId ? nameMap?.resellers[resellerId] || 'N/A' : 'N/A'}
                                label={'Reseller Name'}
                                size={12}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <FormDisabledText value={location?.Country || 'N/A'} label={'Country'} size={12} />
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
};
